import React from 'react';
import './css/App.css';
import About from "./components/About.js"
import Profile from "./components/Profile.js"
import Technologies from "./components/Technologies.js"
import Projects from "./components/Projects.js"
const info = require('./assets/info.json')

const App = () => {
  return (
    <div className="App">
      <div className="info">
        <About />
        <Profile />
        <Technologies info={info.technologies}/>
      </div>
      <Projects info={info.projects}/>
    </div>
  );
}

export default App;
